import HttpFactory from '@/mixins/http.factory';
export default {
	name:'reset-password',
  mixins:[HttpFactory],
	data () {
    return {
      email:'',
      password:'',
      confirmPassword:'',
      showForm:true,
    }
  },
   watch: {
    '$route': 'validateToken'
  },
  methods: {
  	validateToken(){

  	},
    async setAccountPassword () {
      const _self=this;
      let token=this.$route.params.token;
      let userId=this.$route.params.userId;
      let data={
        userId:userId,
        token:token,
        newPassword:this.password
      };
      _self.fn().clearMessage();
			try{
				let response =await _self.post('auth/resetPassword',data);
				if(response && response.data && response.data.Success && response.data.Response){
          _self.showForm=false;
          _self.clear();
          setTimeout(function(){_self.showForm=true;},300);
          _self.messageType='success';
          _self.userMsg.list=[response.data.Response.Message];
				}else{
					_self.userMsg.list=['An error occurred!! Please try again later'];
				}
			}catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
        _self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
  },
  showAlert(msg){
    this.showToasterMsg(msg,false);
  },
  clear(){
    this.password='';
    this.confirmPassword='';
  }
	}
}

